import { Link } from 'gatsby';
import SoftwareArticles from 'components/Software/Android/IntroAndroid';
import NavButtons from 'components/Software/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  SoftwareArticles,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};